import { render, staticRenderFns } from "./zfPackage.vue?vue&type=template&id=32542656&scoped=true&"
import script from "./zfPackage.vue?vue&type=script&lang=js&"
export * from "./zfPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32542656",
  null
  
)

export default component.exports